import { Box, Card, Grid, Pagination, Typography } from '@mui/material';
import { useStyles } from '../styles/Report.styles';
import { ErrorBoundary } from 'react-error-boundary';
import { ReportErrorBoundary } from './ReportErrorBoundary';
import React, { type ReactNode } from 'react';
import { ReportTableCustomSort } from './ReportTableCustomSort';

export interface ReportTableOptions {
    headers: string[];
    data: (string | number | React.ReactNode)[][];
    summaries: ((data: string[] | number[]) => number | string)[];
    sort: ((rowA: string | number, rowB: string | number, direction: 'ascending' | 'descending') => number)[];
    style?: (((data: string | number) => string | number) | null)[];
}

interface ReportLayoutProps {
    title: string;
    pageNum: number;
    numPages: number;
    filter: React.ReactNode;
    action: React.ReactNode;
    tableOptions: ReportTableOptions;
    loadingData: boolean;
    setPageNum: (value: number) => void;
    noResultsText?: ReactNode;
}

export const ReportLayout = ({
    title,
    pageNum,
    numPages,
    tableOptions,
    filter,
    action,
    loadingData,
    setPageNum,
    noResultsText,
}: ReportLayoutProps) => {
    const classes = useStyles();

    return (
        <ErrorBoundary fallback={<ReportErrorBoundary />}>
            <Card className={classes.root}>
                <Grid container direction='row' className={classes.wrapper}>
                    <Grid container direction={'row'} columnGap={2}>
                        <Grid
                            container
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                            paddingBottom={'20px'}>
                            <Typography variant='h5'>{title}</Typography>

                            <Box display={'flex'} flex={1} justifyContent={'flex-end'} alignItems={'center'}>
                                {action}
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        display={'flex'}
                        xs={12}
                        md={12}
                        sm={12}
                        justifyContent={'flex-start'}
                        lg={12}
                        rowGap={2}
                        columnGap={2}
                        flexWrap={'wrap'}>
                        {filter}
                    </Grid>

                    <Grid item xs={12} justifyContent={'center'} padding={'20px'}>
                        <ReportTableCustomSort
                            reportName={title}
                            tableOptions={tableOptions}
                            loading={loadingData}
                            height={500}
                            noResultsText={noResultsText}
                        />
                    </Grid>
                </Grid>

                <Grid
                    item
                    xs={12}
                    justifyContent={'flex-end'}
                    display={'flex'}
                    alignItems={'flex-end'}
                    width={'100%'}
                    paddingTop={'10px'}>
                    <Pagination page={pageNum} onChange={(_, page) => setPageNum(page)} count={numPages} />
                </Grid>
            </Card>
        </ErrorBoundary>
    );
};
